import { type Signal, useMonitor } from "@suse-o11y/signal";
import React from "react";

import { cx } from "~/tools/class-variance";

import type { TimeRange } from "../../app/state/view/timeline/TimeRange";
import { SpecificRange } from "../../app/state/view/timeline/TimeRange";
import { TICK_GAP } from "../../bottom_content/view/highlights-perspective/utils";
import type { Api } from "../../common/openapi";
import { Group } from "../_canvas";
import { Timeline, TimelineEventBucketsWithLogLevels, TimelineTimeTicks } from "../_timeline";

export interface HistogramChartProps {
	timeRange: Signal<TimeRange>;
	buckets: undefined | Array<Api.KubernetesLogHistogramBucket>;
	className?: string;
}

export const HistogramChart = React.forwardRef<HTMLDivElement, HistogramChartProps>(
	({ timeRange, buckets, className }, ref) => {
		const monitor = useMonitor();

		return (
			<Timeline
				brush={{
					onBrush: (left, right) => timeRange.write(new SpecificRange(left, right)),
					areaOffsetBottom: 14,
				}}
				className={cx("w-full max-w-full", className)}
				controlsOffsetBottom={12}
				controlsOffsetTop={-12}
				data-testid="histogram-chart"
				disabled={buckets == null}
				height={67}
				hideTimestamp
				ref={ref}
				timeRange={timeRange.read(monitor)}
			>
				<Group y={15}>
					<TimelineEventBucketsWithLogLevels buckets={buckets} height={30} />
					<TimelineTimeTicks tickGap={TICK_GAP} y={40} />
				</Group>
			</Timeline>
		);
	},
);
